(() => {
  async function getProduct() {
    try {
      const r = await fetch(`${location.pathname}.js`, { credentials: "same-origin" });
      if (!r.ok) return null;
      return await r.json();
    } catch {
      return null;
    }
  }

  function normalise(v) {
    return String(v || '').trim().toLowerCase();
  }

  function allowedCoverages(product, wattageVal) {
    const allowed = new Set();
    const targetWatt = normalise(wattageVal);

    (product.variants || []).forEach(v => {
      if (normalise(v.option1) !== targetWatt) return;
      allowed.add(String(v.option2));
    });

    return allowed;
  }

  function apply(variantSelectsEl, product) {
    const wattage = variantSelectsEl.querySelector('select[name="option-1"]');
    const coverage = variantSelectsEl.querySelector('select[name="option-2"]');
    if (!wattage || !coverage) return;

    const allowed = allowedCoverages(product, wattage.value);
    if (!allowed.size) return;

    const options = Array.from(coverage.options);

    options.forEach(o => {
      const ok = allowed.has(o.value);
      o.hidden = !ok;
      o.disabled = !ok;
    });

    if (!allowed.has(coverage.value)) {
      const first = options.find(o => !o.disabled);
      if (first) {
        coverage.value = first.value;
        coverage.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  async function init(vs) {
    const product = await getProduct();
    if (!product) return;

    apply(vs, product);

    vs.addEventListener('change', () => apply(vs, product));

    // Yuva / Globo / dynamic safety
    new MutationObserver(() => apply(vs, product))
      .observe(vs, { childList: true, subtree: true });
  }

  function boot() {
    document.querySelectorAll('variant-selects').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
